import { AnyAction } from "redux";
import {
  REQUEST_FETCH_DISTRICT,
  REQUEST_FETCH_DISTRICT_ERROR,
  REQUEST_FETCH_DISTRICT_SUCCESS,
} from "redux/actions/general/district";

const defaultState = {
  data: [],
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_DISTRICT:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_FETCH_DISTRICT_SUCCESS:
      return {
        data: action.districts,
        error: null,
        loading: false,
      };
    case REQUEST_FETCH_DISTRICT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
